export const COLORS = {
  success: {
    background: "#dcedc8",
    color: "#00bf73",
    border: "#00bf73",
  },
  info: {
    background: "#e5f6fd",
    color: "#008dff",
    border: "#008dff",
  },
  warning: {
    background: "#ffecb3",
    color: "#ff931e",
    border: "#ff931e",
  },
  error: {
    background: "#ffd4ca",
    color: "#ff0002",
    border: "#e53935",
  },
  default: {
    background: "#f8f9fa",
    color: "#6c757d",
    border: "#f0f0f0",
  },
  violet: {
    background: "#ede7f6",
    color: "#5e35b1",
    border: "#5e35b1",
  },
  text: "#414141",
  cardBackground: "#fff",
}
